import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {scaleNumber} from "../../lq_js_common/helpers/scaling";
import {lerpGreenToRedViaOrange} from "../../helpers/scaling";

export class ShaperCircuitAsn extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.tableId = `circuitAsnTable_${slot}`;
    }

    title() { return "Circuit ASN Overview"; }

    channelRequests() { return ["CircuitAsn"]; }

    buildContainer() {
        const base = super.buildContainer();
        const table = document.createElement("table");
        table.className = "table table-sm table-striped table-hover mb-0";
        table.id = this.tableId;
        table.innerHTML = `
          <thead>
            <tr>
              <th>ASN</th>
              <th class="text-end">Flows</th>
              <th class="text-end">Bytes Down</th>
              <th>Download Share</th>
              <th class="text-end">Bytes Up</th>
              <th class="text-end">Rxmit Down %</th>
              <th class="text-end">Rxmit Up %</th>
              <th class="text-end">RTT Down (ms)</th>
              <th class="text-end">RTT Up (ms)</th>
            </tr>
          </thead>
          <tbody></tbody>
        `;
        base.appendChild(table);
        return base;
    }

    onMessage(msg) {
        if (!msg.Data || msg.Data.target !== "circuit_asn") return;
        const data = msg.Data.blob; // { circuit_hash, rows: [..] }
        const tbody = document.querySelector(`#${this.tableId} tbody`);
        if (!tbody) return;
        tbody.innerHTML = "";

        // Sort descending by bytes_down
        const rows = [...data.rows].sort((a,b) => Number(b.bytes_down) - Number(a.bytes_down));
        const maxDown = rows.reduce((m, r) => Math.max(m, Number(r.bytes_down) || 0), 0);
        rows.forEach(r => {
            const tr = document.createElement("tr");
            // Build colored indicators matching heatmap grading
            const rxDownStr = (r.retransmit_down_percent != null)
                ? `<span class="muted" style="color: ${lerpGreenToRedViaOrange(Math.max(0, 10 - Number(r.retransmit_down_percent)), 10)}">■</span> ${Number(r.retransmit_down_percent).toFixed(2)}`
                : "-";
            const rxUpStr = (r.retransmit_up_percent != null)
                ? `<span class="muted" style="color: ${lerpGreenToRedViaOrange(Math.max(0, 10 - Number(r.retransmit_up_percent)), 10)}">■</span> ${Number(r.retransmit_up_percent).toFixed(2)}`
                : "-";
            // RTT values are reported in hundredths of a millisecond; convert to ms for display and color
            const rttDownMs = (r.rtt_down_median != null) ? (Number(r.rtt_down_median) / 100) : null;
            const rttUpMs = (r.rtt_up_median != null) ? (Number(r.rtt_up_median) / 100) : null;
            const rttDownStr = (rttDownMs != null)
                ? `<span class="muted" style="color: ${lerpGreenToRedViaOrange(Math.max(0, 200 - rttDownMs), 200)}">■</span> ${rttDownMs.toFixed(1)}`
                : "-";
            const rttUpStr = (rttUpMs != null)
                ? `<span class="muted" style="color: ${lerpGreenToRedViaOrange(Math.max(0, 200 - rttUpMs), 200)}">■</span> ${rttUpMs.toFixed(1)}`
                : "-";

            const sharePct = maxDown > 0 ? (Number(r.bytes_down) / maxDown) * 100 : 0;
            const barPct = sharePct > 0 ? Math.max(3, sharePct) : 0; // ensure minimal visibility
            const shareBar = `
              <div class="progress" style="height:6px;">
                <div class="progress-bar bg-secondary" role="progressbar" style="width: ${barPct.toFixed(0)}%" aria-valuenow="${barPct.toFixed(0)}" aria-valuemin="0" aria-valuemax="100"></div>
              </div>`;

            tr.innerHTML = `
              <td>${r.name}</td>
              <td class="text-end">${Number(r.flow_count).toLocaleString()}</td>
              <td class="text-end">${scaleNumber(Number(r.bytes_down), 1)}</td>
              <td>${shareBar}</td>
              <td class="text-end">${scaleNumber(Number(r.bytes_up), 1)}</td>
              <td class="text-end">${rxDownStr}</td>
              <td class="text-end">${rxUpStr}</td>
              <td class="text-end">${rttDownStr}</td>
              <td class="text-end">${rttUpStr}</td>
            `;
            tbody.appendChild(tr);
        });
    }
}
